/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../icon/icon.component.ngfactory';
import * as import2 from '@angular/common';
import * as import3 from '../icon/icon.component';
import * as import4 from './toggle.component';
const styles_ToggleComponent:any[] = ([] as any[]);
export const RenderType_ToggleComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ToggleComponent,
  data: {}
}
);
export function View_ToggleComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-icon',[
      [
        'class',
        'toggle-indicator'
      ]
      ,
      [
        'name',
        'angle-down'
      ]

    ]
    ,(null as any),(null as any),(null as any),import1.View_IconComponent_0,import1.RenderType_IconComponent)),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['active']),
      import0.ɵdid(573440,(null as any),0,import3.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.ToggleComponent = v.component;
    const currVal_0:any = 'toggle-indicator';
    const currVal_1:any = ck(v,2,0,co.active);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = 'angle-down';
    ck(v,3,0,currVal_2);
  },(null as any));
}
function View_ToggleComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',([] as any[]),(null as any),(null as any),(null as any),View_ToggleComponent_0,RenderType_ToggleComponent)),
    import0.ɵdid(573440,(null as any),0,import4.ToggleComponent,[import0.ChangeDetectorRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ToggleComponentNgFactory:import0.ComponentFactory<import4.ToggleComponent> = import0.ɵccf('woa-toggle',import4.ToggleComponent,View_ToggleComponent_Host_0,{active: 'active'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvdG9nZ2xlL3RvZ2dsZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC91aS1lbGVtZW50cy90b2dnbGUvdG9nZ2xlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvdG9nZ2xlL3RvZ2dsZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvdWktZWxlbWVudHMvdG9nZ2xlL3RvZ2dsZS5jb21wb25lbnQudHMuVG9nZ2xlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHdvYS1pY29uIGNsYXNzPVwidG9nZ2xlLWluZGljYXRvclwiIG5hbWU9XCJhbmdsZS1kb3duXCIgW25nQ2xhc3NdPVwieydhY3RpdmUnOiBhY3RpdmV9XCI+PC93b2EtaWNvbj5cbiIsIjx3b2EtdG9nZ2xlPjwvd29hLXRvZ2dsZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFxRDtrQkFBckQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUErRjs7OztJQUFyRjtJQUEyQztJQUFyRCxTQUFVLFVBQTJDLFNBQXJEO0lBQW1DO0lBQW5DLFNBQW1DLFNBQW5DOzs7OztJQ0FBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ui-elements/toggle/toggle.component.ngfactory.ts